import { useRouter } from "next/router";
import { Board, Shipment } from "../../../reducers/uploadedBoard";
import { MY_ACCOUNT } from "../../../constants/routes";
import { useAppSelector } from "../../../utils/hooks/store";
import * as styledElements from "./QuoteStyles";
import BoardCard from "../../boardViews/BoardCard";
import { useBoardFromContext } from "../../../utils/hooks/commonly-stored/uploaded-board/board";
import { ADMIN_GROUP, ENGINEER_GROUP } from "../../../utils/group";
import React from "react";
import UpdateCustomQuote from "./UpdateCustomQuote";
import CustomerMessages from "./CustomerMessages";
import { DEMO_BOARD_SLUG } from "../../../constants/boards";
import QuoteHistory from "./QuoteHistory";
import QuoteBreakdown from "./Breakdown";
import Shipments from "./Shipments";
import useShipmentsFromContext from "../../../utils/hooks/commonly-stored/uploaded-board/shipments";

export default function Quote() {
  const router = useRouter();
  const { groups } = useAppSelector((state) => state.auth);
  const board = useBoardFromContext().board as Board;
  const shipments = useShipmentsFromContext(board.id) as Shipment[];
  const isDemoBoard = board.id == DEMO_BOARD_SLUG;
  const showEngineerTools =
    (groups.includes(ADMIN_GROUP) || groups.includes(ENGINEER_GROUP)) &&
    !isDemoBoard;

  const sendUserToMyAccountPage = () => {
    void router.push(MY_ACCOUNT);
  };

  const updatingCustomQuote =
    board.quote.requested_custom_quote && board.quote.total === null;
  const hideBreakdown = updatingCustomQuote && showEngineerTools;
  return (
    <styledElements.Body>
      <BoardCard
        board={board}
        shipments={shipments}
        hideOrderSummary
        onDelete={sendUserToMyAccountPage}
      />
      {!isDemoBoard && (
        <>
          <Shipments />
          <CustomerMessages />
          {!hideBreakdown && <QuoteBreakdown />}
        </>
      )}
      {showEngineerTools && (
        <>
          {updatingCustomQuote && <UpdateCustomQuote />}
          <QuoteHistory />
        </>
      )}
    </styledElements.Body>
  );
}
